import React, { useEffect, useState } from "react";
import axios from "axios";
import { initializeApp } from "firebase/app";
import { getFirestore, doc, updateDoc } from "firebase/firestore";
import mqtt from "mqtt";
import { sendData } from "../Pages/FilterSubCom";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SideBar from "./SideBar";
import i18n from "../Components/i18n";
let mqttClient = null;
function parseTimestamp(timestamp) {
  try {
    const [datePart, timePart] = timestamp.split(" ");
    const [day, month, year] = datePart.split("/").map(Number);
    const [hour, minute, second] = timePart.split(":").map(Number);

    return new Date(year, month - 1, day, hour, minute, second);
  } catch (e) {
    // console.log(e);
    return new Date();
  }
}

const OnlineIcon = ({ timestamp }) => {
  //console.log(timestamp, "timestamp");
  const [isOnline, setIsOnline] = useState(false);

  useEffect(() => {
    const updateColor = () => {
      const currentTime =
        new Date().getTime() + new Date().getTimezoneOffset() * 60000;
      if (!timestamp) return false; // 🔒 Reject empty/null/undefined
 if(timestamp?.length < 3) return false; 
      const date = parseTimestamp(timestamp);
      if (isNaN(date.getTime())) return false;

      const lastHeartbeat = date.getTime();
      const timeDifference = (currentTime - lastHeartbeat) / 1000; // Convert to seconds

      const isOnline = timeDifference <= 10; // 10 seconds

      setIsOnline(isOnline);
    };

    updateColor();
    const interval = setInterval(updateColor, 1000);

    return () => clearInterval(interval);
  }, [timestamp]);

  return (
    <>
      <div
        style={{
          width: "12px",
          height: "12px",
          borderRadius: "50%",
          backgroundColor: isOnline ? "#28a745" : "#dc3545",
          boxShadow: isOnline ? "0px 0px 8px #28a745" : "none",
          animation: isOnline ? "pulse 1s infinite" : "none",
          marginBlock: "5px",
        }}
      ></div>
      <style>
        {`
      .spinner {
        border: 4px solid rgba(0, 0, 0, 0.1);
        border-left-color: #8ec0fc;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        display:flex
      }
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
      @keyframes pulse {
        0% {
          box-shadow: 0 0 5px #28a745;
        }
        50% {
          box-shadow: 0 0 15px #28a745;
        }
        100% {
          box-shadow: 0 0 5px #28a745;
        }
      }
    `}
      </style>
    </>
  );
};
function Table({ children, toggleLanguage }) {
  const location = useLocation();
  const [onlineStatus, setOnlineStatus] = useState({}); 

 
  const [AllChecked, setAllChecked] = useState(false);
  const [loading2, setloading2] = useState(true);
  const [dataArr, setDataArr] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [Search, setSearch] = useState("");
  const navigate = useNavigate();
  const { t } = useTranslation();

  //////////////get all users///////////////
  const fetchData = async () => {
    fetch(`https://db2sg.com/HamitaherApi/user.php`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `HTTP error! Status: ${response?.status} ${response?.statusText}`
          );
        }

        return response.json();
      })
      .then((result) => {
        console.log(result, "result");
       
        const userType = localStorage.getItem("usertype");
console.log(userType)
let filtered = result;

// FILTER RULES
if (userType === "admin") {
  // show all except admins
  filtered = result.filter(u => u.userType !== "admin");
}

else if (userType === "sitemanager") {
  filtered = result.filter(
    u => u.userType === "technician" || u.userType === "user"
  );
}

else if (userType === "technician") {
  filtered = result.filter(u => u.userType === "user");
}

// else if (userType === "user") {
//   filtered = result.filter(u => u.email === userEmail);
// }
console.log(filtered)
setDataArr(filtered);
        setFilteredData(filtered); // Set initial filtered data to all data
        setloading2(false);
      })
      .catch((error) => {
        console.log(error, "Error");
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    mqttClient = null
    if (mqttClient) return; 
  
    mqttClient = mqtt.connect("wss://mqtt.db2sg.com:9001/mqtt"); // your broker
  
    mqttClient.on("connect", () => {
      console.log("MQTT Connected");
      mqttClient.subscribe("#");  // DW/deviceId/heartbeat
    });
  
    mqttClient.on("message", (topic, message) => {
      if (!topic.includes("heartbeat")) return;
      const parts = topic.split("/");
      //const deviceId = parts[1];
      const deviceId = topic.split("/")[0];
      setOnlineStatus(prev => ({
        ...prev,
        [deviceId]: message?.toString(),  
               // mark online
      }));
  console.log(onlineStatus)

    });
  
    return () => {
      if (mqttClient) mqttClient.end();
    };
  }, []);
  const [anyUserSelected, setanyUserSelected] = useState(false);
  useEffect(() => {
    for (let i = 0; i < filteredData.length; i++) {
      if (filteredData[i].checked) {
        return setanyUserSelected(true);
      }
    }
    setanyUserSelected(false);
  }, [filteredData]);

  useEffect(() => {
    const lowercasedSearch = Search.toLowerCase();
    if (lowercasedSearch !== "") {
      const filtered = dataArr.filter((item) => {
        // return item.users?.some((user) => {
        return (
          item.email?.toLowerCase().includes(lowercasedSearch) ||
          item.orgName?.toLowerCase().includes(lowercasedSearch) ||
          item.name?.toLowerCase().includes(lowercasedSearch) ||
          item.userType?.toLowerCase().includes(lowercasedSearch)
        );
        // });
      });

      setFilteredData(filtered);
    } else {
      setFilteredData(dataArr);
    }
  }, [Search, dataArr]);

  const [notificationopen, setnotificationOpen] = useState(false);

  const handlenotificationOpen = () => {
    setnotificationOpen(true);
  };

  const handlenotificationClose = () => {
    setnotificationOpen(false);
  };

  const [userupdateopen, setuserupdateOpen] = useState(false);

  const [selectedType, setselectedType] = useState(false);
  const [selectedName, setselectedName] = useState("");
  const [selectedId, setselectedId] = useState("");

  const handleuserupdateOpen = async () => {
    setuserupdateOpen(true);
  };

  const handleuserupdateClose = () => {
    setuserupdateOpen(false);
  };

  const handlenotificationSubmit = ({ title, body }) => {
    console.log("Form data:", { title, body });
    // Handle form submission logic here
    let arr = [];
    filteredData.forEach((e) => {
      if (e.checked) {
        arr.push(e.fcmToken);
        sendData(
          "user/unotification",
          JSON.stringify({ token: e.fcmToken, title: title, body: body })
        );
      }
    });
  };

  // import { auth } from "../firebase/firebase"; // Import Firebase config

  const firebaseConfig = {
    apiKey: "AIzaSyCCZs0KeYn-GRUHhUDjQqTdBcikNMgejSw",
    authDomain: "digital-well-424806-d4.firebaseapp.com",
    appId: "1:113404369101:web:6d1fa706ef9ff025c57184",
    messagingSenderId: "113404369101",
    projectId: "digital-well-424806-d4",
    storageBucket: "digital-well-424806-d4.appspot.com",
    measurementId: "G-0TZLGZ3BZW",
  };

  // const app = initializeApp(firebaseConfig);

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app);

  const handleuserupdateSubmit = async ({ role, id, userName }) => {
    console.log("Form data:", role, id, userName);
    try {
      const userRef = doc(db, "users", id);

      await updateDoc(userRef, {
        name: userName,
        userType: role,
        lastUpdatedAt: new Date(), // optional, like your Dart version
      });

      console.log("✅ User profile updated successfully!");
    } catch (error) {
      console.error("❌ Error updating user data:", error);
    }
  };

  const [Otaopen, setOtaOpen] = useState(false);

  const handleOtaClose = () => {
    setOtaOpen(false);
  };

  const handleOtaOpen = () => {
    setOtaOpen(true);
  };

  // const { t } = useTranslation();
  const formatTimestamp = ({ _seconds, _nanoseconds }) => {
    const timestamp = _seconds * 1000 + _nanoseconds / 1000000;
    const date = new Date(timestamp);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    });
  };

  const [sortConfig, setSortConfig] = React.useState({
    key: "",
    direction: "asc",
  });
  const parseCreatedAt = (createdAt) => {
    if (!createdAt || typeof createdAt !== "object") return null;
  
    const seconds = createdAt._seconds;
    const nanos = createdAt._nanoseconds || 0;
  
    if (typeof seconds !== "number") return null;
  
    return seconds * 1000 + nanos / 1e6; // milliseconds
  };
  
  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        // Same column clicked — toggle direction
        const newDirection = prev.direction === "asc" ? "desc" : "asc";
        return { key, direction: newDirection };
      }
      // New column clicked — default to asc
      return { key, direction: "asc" };
    });
  };
  const [selectedUserDevices, setSelectedUserDevices] = useState({});

  function getDeviceCount(val) {
    if (Array.isArray(val)) return val.length; // array → count elements
    const n = Number(val);
    return Number.isFinite(n) ? n : 0; // number-like → number, else 0
  }

  const sortedData = React.useMemo(() => {
    if (!sortConfig.key) return filteredData;

    const sorted = [...filteredData].sort((a, b) => {
      let valA = a[sortConfig.key];
      let valB = b[sortConfig.key];
      if (sortConfig.key === "createdAt") {
        const timeA = parseCreatedAt(valA);
        const timeB = parseCreatedAt(valB);
  
        if (timeA == null || timeB == null) return 0;
  
        return sortConfig.direction === "asc"
          ? timeA - timeB
          : timeB - timeA;
      }
      // Special case: sort devices by length
      if (sortConfig.key === "devices") {
        const lenA = Array.isArray(valA)
          ? valA.length
          : String(valA || "").length;
        const lenB = Array.isArray(valB)
          ? valB.length
          : String(valB || "").length;
        if (lenA < lenB) return sortConfig.direction === "asc" ? -1 : 1;
        if (lenA > lenB) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      }
      if (sortConfig.key === "devices") {
        valA = getDeviceCount(valA);
        valB = getDeviceCount(valB);
      }

      // Normalize null/undefined
      if (valA === undefined || valA === null) valA = "";
      if (valB === undefined || valB === null) valB = "";

      // Case-insensitive comparison for strings
      const strA = String(valA).toLowerCase();
      const strB = String(valB).toLowerCase();

      if (strA < strB) return sortConfig.direction === "asc" ? -1 : 1;
      if (strA > strB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });

    return sorted;
  }, [filteredData, sortConfig]);

  return (
    <>
      <SideBar />
      <div className="topbar" style={{ backgroundColor: "#8ec0fc" }}>
        <div className="container-fluid devices_topbar">
          <div className="row d-flex align-items-center justify-content-evenly">
            <div className="col text-center px-3 d-flex flex-start">
              <span
                className="mb-0"
                style={{
                  color: "#000",
                  fontSize: "100%",
                  background:
                    "linear-gradient(45deg, #000, #000, #000, #000)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                {localStorage.getItem("name")?.toUpperCase()}
              </span>
            </div>

            <div
              className="col-2 d-flex align-items-center"
              style={{ width: localStorage.getItem("usertype") === "user" ? 
"160px":"600px", justifyContent: "space-between" }}
            >
              {localStorage.getItem("usertype") === "user" ? 
null:
              <><button
                  disabled={!anyUserSelected}
                  onClick={() => {
                    handleOtaOpen();
                  } }
                  className="btn"
                  style={{
                    background: !anyUserSelected
                      ? "grey"
                      : "linear-gradient(45deg, #225a9f, #225a9f, #225a9f,#225a9f)",
                    color: !anyUserSelected ? "#fff" : "#fff",
                    cursor: "pointer",
                  }}
                >
                  Publish Ota
                </button><button
                  disabled={!anyUserSelected}
                  style={{
                    background: !anyUserSelected
                      ? "grey"
                      : "linear-gradient(45deg, #225a9f, #225a9f, #225a9f,#225a9f)",
                    color: !anyUserSelected ? "#fff" : "#fff",
                    cursor: "pointer",
                    marginLeft: "10px",
                  }}
                  onClick={() => {
                    handlenotificationOpen();
                  } }
                  className="btn"
                >
                    Notification
                  </button><span
                    style={{
                      color: "#000",
                      background: "linear-gradient(45deg, #000, #000, #000, #000)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      fontSize: "100%",
                      marginLeft: "20px",
                    }}
                  >
                    {t("Select All")}
                  </span><label className="switch">
                    <input
                      type="checkbox"
                      checked={AllChecked}
                      onChange={(e) => {
                        setAllChecked(e.target.checked);
                        const tempCopy = filteredData.map((element) => ({
                          ...element,
                          checked: e.target.checked,
                        }));
                        setFilteredData(tempCopy);
                      } }
                      name="loading" />
                    <span className="slider"></span>
                  </label></>
}
              <span
                style={{
                  color: "#000",
                  background:
                    "linear-gradient(45deg, #000, #000, #000, #000)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: "100%",
                  marginLeft: "20px",
                }}
              >
                {i18n.language === "en" ? "Hebrew" : "Hebrew"}
              </span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={i18n.language === "he"}
                  onChange={toggleLanguage}
                  name="loading"
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className="content">
        <div className="container-fluid mt-1 mb-4">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <h5 className="mt-2" style={{ color: "#8ec0fc" }}>
                {localStorage.getItem("usertype") === "user"
                  ? t("Dashboard")
                  : t("Management")}
              </h5>
            </div>
            <div className="col-auto">
              <div className="search-container d-flex align-items-center">
                <input
                  value={Search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                  style={{
                    background:
                      "linear-gradient(45deg, #000, #000, #000, #000)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                  type="text"
                  className="search-input"
                  placeholder={t("Search")}
                />
              </div>
            </div>
          </div>
        </div>
        {loading2 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "70vh",
            }}
          >
            <div className="spinner"></div>
          </div>
        ) : (
          <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
            <table className="table table-striped table-responsive">
              <thead
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#fff",
                  zIndex: 2,
                }}
              >
                <tr
                  style={{
                    cursor: "pointer",
                    fontSize: "95%",
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                >
                  <th
                    style={{
                      textAlign: "center",
                      fontSize: "100%",
                      padding: "8px",
                    }}
                    scope="col"
                    onClick={() => handleSort("name")}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center", // vertical centering
                        justifyContent: "center", // horizontal centering
                        gap: "4px",
                      }}
                    >
                      <span>{t("Name")} </span>
                      <span
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          lineHeight: "10px",
                        }}
                      >
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "name" &&
                              sortConfig.direction === "asc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▲
                        </span>
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "name" &&
                              sortConfig.direction === "desc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▼
                        </span>
                      </span>
                    </div>
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      fontSize: "100%",
                      padding: "8px",
                    }}
                    scope="col"
                    onClick={() => handleSort("createdAt")}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center", // vertical centering
                        justifyContent: "center", // horizontal centering
                        gap: "4px",
                      }}
                    >
                      <span>{t("Date Created")} </span>
                      <span
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          lineHeight: "10px",
                        }}
                      >
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "createdAt" &&
                              sortConfig.direction === "asc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▲
                        </span>
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "createdAt" &&
                              sortConfig.direction === "desc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▼
                        </span>
                      </span>
                    </div>
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      fontSize: "100%",
                      padding: "8px",
                    }}
                    scope="col"
                    onClick={() => handleSort("userType")}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center", // vertical centering
                        justifyContent: "center", // horizontal centering
                        gap: "4px",
                      }}
                    >
                      <span>{t("Role")}</span>
                      <span
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          lineHeight: "10px",
                        }}
                      >
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "userType" &&
                              sortConfig.direction === "asc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▲
                        </span>
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "userType" &&
                              sortConfig.direction === "desc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▼
                        </span>
                      </span>
                    </div>
                  </th>

                  <th
                    style={{
                      fontSize: "100%",
                      width: "200px",
                      padding: "8px",
                    }}
                    scope="col"
                    onClick={() => handleSort("orgName")}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center", // vertically centers text and arrows
                        justifyContent: "center", // horizontally centers
                        gap: "4px", // space between text and arrows
                      }}
                    >
                      <span>{t("Organization Name")}</span>
                      <span
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          lineHeight: "10px",
                        }}
                      >
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "orgName" &&
                              sortConfig.direction === "asc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▲
                        </span>
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "orgName" &&
                              sortConfig.direction === "desc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▼
                        </span>
                      </span>
                    </div>
                  </th>

                  <th
                    style={{
                      textAlign: "center",
                      fontSize: "100%",
                      width: "110px",
                      padding: "8px",
                    }}
                    scope="col"
                    onClick={() => handleSort("devices")}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center", // <-- vertically center text + arrows
                        justifyContent: "center", // <-- horizontally center
                        gap: "4px", // <-- small space between text and arrows
                      }}
                    >
                      <span>{t("Devices")}</span>
                      <span
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          lineHeight: "10px",
                        }}
                      >
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "devices" &&
                              sortConfig.direction === "asc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▲
                        </span>
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "devices" &&
                              sortConfig.direction === "desc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▼
                        </span>
                      </span>
                    </div>
                  </th>
                  {localStorage.getItem("usertype") === "user" ? 
null:
                  <th scope="col" className="text-center">
                    {t("Action")}
                  </th>}
                  {localStorage.getItem("usertype") === "admin"|| localStorage.getItem("usertype") === "sitemanager"? (
                    <th scope="col" className="text-center">
                      {t("Edit")}
                    </th>
                  ) : null}
                </tr>
              </thead>

              <tbody>
                {sortedData
                  .filter((i) =>
                    location?.state?.role === "admin"
                      ? i.userType === "admin"
                      : location?.state?.role === "technician"
                      ? i.userType === "technician"
                      : location?.state?.role === "user" ||
                        localStorage.getItem("usertype") === "technician"
                      ? i.userType === "user"
                      : localStorage.getItem("usertype") === "user"
                      ? i.email === localStorage.getItem("email")
                      : location?.state?.role === "sitemanager"
                      ? i.userType === "sitemanager"
                      : true
                  )
                  .map((i, index) => (
                    <tr
                      style={{
                        cursor: "pointer",
                        fontSize: "90%",
                        textAlign: "center",
                        verticalAlign: "middle",
                      }}
                      key={index}
                    >
                      <td
                        onClick={() => {
                          navigate("/deviceinfo", { state: i });
                          console.log(i);
                        }}
                      >
                        <div
                          className="d-flex flex-row"
                          style={{
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <img
                              alt=""
                              src={"assets/profile.png"}
                              width={40}
                              height={40}
                            />
                          </div>
                          <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="ps-2 text-dark">
                              <b>{i.name ? i.name : i.esp_id}</b>
                            </div>
                            <span className="ps-2">{i.email}</span>
                          </div>
                        </div>
                      </td>

                      <td
                        style={{ fontSize: "100%", color: "grey" }}
                        onClick={() => {
                          navigate("/deviceinfo", { state: i });
                          console.log(i);
                        }}
                      >
                        {i?.createdAt?._seconds
                          ? formatTimestamp(i?.createdAt)
                          : ""}
                      </td>
                      <td
                        style={{
                          fontSize: "100%",
                          color: "grey",
                          textAlign: "center",
                        }}
                        onClick={() => {
                          navigate("/deviceinfo", { state: i });
                          console.log(i);
                        }}
                      >
                        {i.userType}
                      </td>
                      <td
                        style={{ fontSize: "100%", color: "grey" }}
                        onClick={() => {
                          navigate("/deviceinfo", { state: i });
                          console.log(i);
                        }}
                      >
                        {i.orgName}
                      </td>
                      <td style={{ fontSize: "100%", color: "grey" }}>
  {["sitemanager", "admin", "technician"].includes(i.userType) ? (
    "0"
  ) : i.devices ? (
    <div>
      <strong>{Object.keys(i.devices).length}</strong>

      <div
        style={{
          marginTop: "6px",
          borderTop: "1px solid #ccc",
          paddingTop: "6px",
        }}
      >
        {Object.keys(i.devices)
          .sort((a, b) => a.localeCompare(b)) // Sort alphabetically
          .map((devId, index, arr) => {
            return (
              <div key={devId} style={{ padding: "4px 0" }}>
                <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
  
  {/* ONLINE / OFFLINE DOT */}
  {/* <span
    style={{
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      backgroundColor: onlineStatus[devId] ? "green" : "red",
      display: "inline-block",
    }}
  ></span> */}
<OnlineIcon timestamp={onlineStatus[devId]}></OnlineIcon>
  {/* DEVICE ID */}
  <span
    style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
    onClick={() => {
      if ((i?.devices || "{}")[devId]
      ?.provisioned) {
        navigate("/devicesdata", {
          state: {
            deviceName: (i?.devices || "{}")[devId]
            ?.deviceName,
            enabled: (i?.devices || "{}")[devId]
              ?.enabled,
            esp_id: devId,
            provisioned: (i?.devices || "{}")[devId]
              ?.provisioned,
            user: i,
          },
        });
      } else {
        alert(
          "Device not provisioned: First provision it from the app"
        );
      }
    }}
  >
    {devId}
  </span>
</span>
                {/* <span
                  style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
                  onClick={() => {
                    if ((i?.devices || "{}")[devId]
                    ?.provisioned) {
                      navigate("/devicesdata", {
                        state: {
                          deviceName: (i?.devices || "{}")[devId]
                          ?.deviceName,
                          enabled: (i?.devices || "{}")[devId]
                            ?.enabled,
                          esp_id: devId,
                          provisioned: (i?.devices || "{}")[devId]
                            ?.provisioned,
                          user: i,
                        },
                      });
                    } else {
                      alert(
                        "Device not provisioned: First provision it from the app"
                      );
                    }
                  }}
                >
                  {devId}
                </span> */}

                {index !== arr.length - 1 && (
                  <div style={{ borderBottom: "1px solid #ddd", margin: "4px 0" }} />
                )}
              </div>
            );
          })}
      </div>
    </div>
  ) : (
    "0"
  )}
</td>
{localStorage.getItem("usertype") === "user" ? 
null:
                      <td style={{ width: "12%" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                          className="text-center"
                        >
                          <img
                            alt=""
                            src={"assets/cloud.png"}
                            width={20}
                            height={20}
                            onClick={() => {
                              i.checked
                                ? handleOtaOpen()
                                : alert("Please Select user");
                            }}
                            style={{
                              cursor: "pointer",
                              filter:
                                "sepia(0) saturate(140) brightness(0.9) hue-rotate(200deg)",
                            }}
                          />
                          <img
                            alt=""
                            src="assets/notification-bell.png"
                            width={20}
                            height={20}
                            onClick={() => {
                              i.checked
                                ? handlenotificationOpen()
                                : alert("Please Select user");
                            }}
                            style={{
                              cursor: "pointer",
                              filter:
                              "sepia(0) saturate(140) brightness(0.9) hue-rotate(200deg)",
                            }}
                          />
                          <div>
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={i.checked}
                                onClick={(e) => {
                                  e.stopPropagation();
                                }}
                                onChange={(e) => {
                                  setFilteredData((temp) => {
                                    const newTemp = [...temp];
                                    newTemp[index].checked = e.target.checked;
                                    return newTemp;
                                  });
                                }}
                                name="loading"
                              />
                              <span className="slider"></span>
                            </label>
                          </div>
                        </div>
                      </td>}
                      {localStorage.getItem("usertype") === "admin"|| localStorage.getItem("usertype") === "sitemanager" ? (
                        <td>
                          <img
                            alt=""
                            onClick={async () => {
                              console.log(i.userType);
                              setselectedType(i.userType);
                              setselectedId(i.id);
                              setselectedName(i.name);
                              setSelectedUserDevices(i.devices || {});
                              console.log(i.userType, i.id);
                              handleuserupdateOpen();
                            }}
                            src={"assets/edit.png"}
                            width={20}
                            height={20}
                            style={{
                              cursor: "pointer",
                              filter:
                              "sepia(0) saturate(140) brightness(0.9) hue-rotate(60deg)",
                            }}
                          />
                        </td>
                      ) : (
                        <td>
                          <div
                            width={20}
                            height={20}
                            style={{
                              cursor: "pointer",
                              filter:
                                "sepia(500) saturate(0) brightness(0) hue-rotate(-7deg)",
                            }}
                          />
                        </td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}

        <NotificationForm
          open={notificationopen}
          onClose={handlenotificationClose}
          onSubmit={handlenotificationSubmit}
        />

        <UserUpdateForm
          open={userupdateopen}
          onClose={handleuserupdateClose}
          onSubmit={handleuserupdateSubmit}
          type={selectedType}
          id={selectedId}
          name={selectedName}
          devices={selectedUserDevices}
        />

        <FileUploadDialog
          open={Otaopen}
          userIds={filteredData.filter((e) => e.checked)}
          onClose={handleOtaClose}
        />
        <style>
          {`
          .spinner {
            border: 4px solid rgba(0, 0, 0, 0.1);
            border-left-color: #8ec0fc;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            display:flex
          }
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
        </style>
      </div>
    </>
  );
}

export default Table;
const FileUploadDialog = ({ open, onClose, userIds }) => {
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");

  const handleFileChange = (event) => {
    let fi = event.target.files[0];
    if (fi.name.split(".").pop() !== "bin") {
      alert("Please upload a valid .bin file");
      return;
    }
    setFile(fi);
    setTitle(fi.name.split(".bin")[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!file || !title) {
      alert("The selected file is not a valid .bin file");

      return;
    }
    let arr = [];
    userIds.forEach((e) => {
      let b = e.devices;
      if (b !== undefined) {
        Object.keys(e.devices).forEach((ele) => {
          arr.push(ele);
        });
      }
    });
    console.log(arr);

    //////////////update ota///////////////

    const formData = new FormData();

    formData.append("file", file);
    formData.append("title", title);
    formData.append("userIds", JSON.stringify(userIds.map((e) => e.id)));
    formData.append("deviceIds", JSON.stringify(arr));
    try {
      await axios.post("https://db2sg.com/HamitaherApi/otas.php", formData);
      alert("File uploaded successfully");
      setFile(null);
      setTitle("");
      onClose();
    } catch (error) {
      console.error("Error uploading file:", error);
    }

    // formData.append("deviceIds", JSON.stringify(arr));
  };
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <div className="modal show" style={{ display: "block" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                onClose();
                setTitle("");
              }}
            ></button>
          </div>
          <div className="modal-body">
            <div className="form_container">
              <div className="form-box">
                <label className="form-label">{t("Upload file")}</label>
                <div className="input-group mb-3">
                  <div className="mb-4">
                    <input
                      type="text"
                      style={{ width: "100%" }}
                      className="input-field mb-4"
                      placeholder={file?.name.split(".bin")[0]}
                    />
                  </div>
                  <div className="mb-4">
                    <input
                      type="file"
                      onChange={handleFileChange}
                      className="mb-4"
                    />
                  </div>
                </div>
                <button
                  onClick={handleSubmit}
                  type="submit"
                  className="submit-button form_button"
                >
                  {t("Submit")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const NotificationForm = ({ open, onClose, onSubmit }) => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const { t } = useTranslation();
  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit({ title, body });
    onClose(); // Close the modal after submission
    setTitle("");
    setBody("");
  };
  if (!open) return null;

  return (
    <div className="modal show" style={{ display: "block" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                onClose();
                setTitle("");
                setBody("");
              }}
            ></button>
          </div>
          <div className="modal-body">
            <div className="form_container">
              <div className="form-box">
                <div className="input-group mb-3">
                  <label className="form-label">{t("Title")}</label>
                  <input
                    type="text"
                    onChange={(e) => setTitle(e.target.value)}
                    className="input-field"
                    placeholder={t("Enter title")}
                  />
                </div>

                <div className="input-group mb-3">
                  <label className="form-label">{t("Body")}</label>
                  <input
                    type="text"
                    onChange={(e) => setBody(e.target.value)}
                    style={{ height: "50px" }}
                    className="input-field"
                    placeholder={t("Enter text")}
                  />
                </div>

                <button
                  onClick={handleSubmit}
                  type="submit"
                  className="submit-button form_button"
                >
                  {t("Submit")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const UserUpdateForm = ({ open, onClose, onSubmit, type, id, name,devices }) => {
  const [role, setRole] = useState(type);
  const [password, setPassword] = useState("");
  const [userName, setUserName] = useState(name);
  const [userDevices, setUserDevices] = useState(devices || {});

  useEffect(() => {
    setRole(type);
    setUserName(name);
    setUserDevices(devices || {});
  }, [type, name,devices]);

  useEffect(() => {
    console.log("Updated role:", role, userName);
  }, [role, userName]);
  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit({ role, id, userName });
    onClose(); // Close the modal after submission
  };
  const handleToggleDevice = (deviceId,e) => {
    // toggle enabled state
    setUserDevices((prev) => ({
      ...prev,
      [deviceId]: {
        ...prev[deviceId],
        enabled: !prev[deviceId]?.enabled,
      },
    }));
    sendData(
      `${deviceId}/enabled`,
e.target.checked?"1":"0"
    )
    console.log(`${deviceId}/enabled`,
    e.target.checked)
  };

  const handleDeleteDevice = (deviceId) => {
    if (!window.confirm("Are you sure you want to delete this device?")) return;
console.log(id,deviceId)
    fetch(`https://db2sg.com/HamitaherApi/delete.php?user_id=${id}&esp_id=${deviceId}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error(
          `HTTP error! Status: ${response?.status} ${response?.statusText}`
        );
      }

      return response.json();
    })
      .then((res) => {
        console.log(res)
        setUserDevices((prev) => {
          const updated = { ...prev };
          delete updated[deviceId];
          return updated;
        });
      })
      .catch(console.error);
  };

  if (!open) return null;
  return (
    <div className="modal show" style={{ display: "block", height: "500px",
    overflowY:"scroll",marginTop:"0px" }}>
      <div className="modal-dialog  " style={{}}>
        <div className="modal-content mt-5">
          <div className="modal-header ">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                onClose();
              }}
            ></button>
          </div>
          <div className="modal-body ">
            <div className="form_container ">
              <div style={{ alignItem: "center", textAlign: "center" }}>
                <label className="form-label">Role</label>
                <select
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    borderRadius: 8,
                    border: "1px solid #ccc",
                    fontSize: "100%",
                    backgroundColor: "#fff",
                    minHeight: "45px",
                    height: "45px",
                  }}
                >
                  <option value="" disabled hidden>
                    Select Role
                  </option>
                  <option value="admin">Admin</option>
                  <option value="sitemanager">Site Manager</option>
                  <option value="technician">Technician </option>
                  <option value="user">User</option>
                </select>
                <label className="form-label" style={{ marginTop: "5px" }}>
                  Name
                </label>
                <input
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    borderRadius: 8,
                    border: "1px solid #ccc",
                    fontSize: "100%",
                    backgroundColor: "#fff",
                  }}
                />
                <label className="form-label" style={{ marginTop: "5px" }}>
                  Password
                </label>
                <div style={{ display: "flex", gap: "10px" }}>
                  <input
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "10px 14px",
                      height: "40px",
                      borderRadius: 8,
                      border: "1px solid #ccc",
                      fontSize: "100%",
                      backgroundColor: "#fff",
                    }}
                  />
                  <button
                    onClick={() => {
                      if (!password) {
                        alert("enter the new password");
                      } else {
                        fetch(
                          `https://db2sg.com/HamitaherApi/updatepassword.php`,
                          {
                            method: "POST",
                            headers: {
                              Accept: "application/json",
                              "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                              uid: id,
                              new_password: password,
                            }),
                          }
                        )
                          .then((response) => {
                            if (!response.ok) {
                              throw new Error(
                                `HTTP error! Status: ${response?.status} ${response?.statusText}`
                              );
                            }

                            return response.json();
                          })
                          .then((result) => {
                            console.log(result, "result");
                            alert(result.message);
                          })
                          .catch((error) => {
                            console.log(error, "Error");
                          });
                      }
                    }}
                    type="submit"
                    className="submit-button mt-0 form_button"
                  >
                    Save
                  </button>
                </div>
                <hr />

<h5>User Devices</h5>
{Object.keys(userDevices).length === 0 && <p>No devices found</p>}
{Object.keys(userDevices).map((deviceId) => (
  <div
    key={deviceId}
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "10px",
    }}
  >
    <div>
    <span>{userDevices[deviceId].deviceName}</span>
    <br/>
    <span>{(deviceId)}</span>

   </div>
  
    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
    {localStorage.getItem("usertype") === "admin"?<label className="switch">
        <input
          type="checkbox"
          checked={userDevices[deviceId].enabled}
          onChange={(e) => handleToggleDevice(deviceId,e)}
        />
        <span className="slider"></span>
      </label>
:null}
      <img
        src="assets/delete.png"
        width={20}
        height={20}
        style={{ cursor: "pointer" }}
        onClick={() => handleDeleteDevice(deviceId)}
        alt="Delete"
      />
    </div>
  </div>
))}
                <button
                  onClick={handleSubmit}
                  type="submit"
                  className="submit-button mt-2 form_button"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
